<template>
	<section>
		<div class="calendar-overview">
			<h4 class="active-title">
				{{ $t('enterprise.financial-calendar') }}
			</h4>
		</div>
		<div class="ir-module-block">
			<CCalendar
				:value.sync="dateValue"
				:scheduleData="scheduleData"
				:styles="['circle-calendar']"
				@cell-click="handleCellClick"
			/>
			<div class="schedule-wrap">
				<CScheduleItem
					v-for="(item, index) in generateLimitedDisplayData(dateValue)"
					:key="index"
					:item="item"
					inline
				></CScheduleItem>
			</div>
			<div class="more position-abs" @click="goToCalendar">
				{{ $t('enterprise.see-more') }}<i class="iconfont iconjiantouyou"></i>
			</div>
		</div>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';
import CCalendar from '@/view/enterprise/components/calendar/c-calendar.vue';
import CScheduleItem from '@/view/enterprise/components/calendar/c-schedule-item.vue';
import { getMonthRange } from '@/store/modules/calendar';
import useScheduleCache from './mixins/useScheduleCache';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { computed } from 'vue';
import { useCurrentContext } from './context';
import { useNavigation } from '@rebuild/hooks/useNavigation';

export default {
	mixins: [useScheduleCache],
	components: {
		CCalendar,
		CScheduleItem
	},
	data() {
		return {
			dateValue: new Date(),
			scheduleData: []
		};
	},
	computed: {
		...mapGetters({
			'getIrBaseInfo': 'getIrBaseInfo'
		})
	},
	watch: {
		dateValue(val) {
			this.UPDATE_SCHEDULE_RENDER(val);
		}
	},
	mounted() {
		this.queryScheduleList(this.dateValue);

		const onScheduleUpdate = () => {
			this.queryScheduleList(this.dateValue);
		};
		this.REGISTER_ON_RENDER_UPDATE(onScheduleUpdate);
	},
	methods: {
		handleCellClick() {
			// 如果切换过其他的日期，后续展示的日程数据就以选中的日期为基准
		},
		async queryScheduleList(date) {
			const [rangeStart, rangeEnd] = getMonthRange(date);
			const _cache = []; // 覆盖缓存
			[
				this.$moment(date).format('YYYYMM'),
				this.$moment(rangeStart).format('YYYYMM'),
				this.$moment(rangeEnd).format('YYYYMM')
			].forEach(d => {
				_cache.push(d);
			});
			// 记录已经拿到数据的日期信息
			this.RESET_CACHED_SCHEDULE_MONTH_KEYS([...new Set(_cache)]);

			await this.loadScheduleList({
				startTime: rangeStart,
				endTime: rangeEnd
			});
			this.scheduleData = this.getScheduleList;
		},

		generateLimitedDisplayData(date) {
			return this.calenderCtx.generateLimitedDisplayData(this.scheduleData, date);
		},
		formatDateFn(data) {
			return this.calenderCtx.formatDateFn(data);
		}
	},
	setup() {
		const ctx = useCurrentContext();
		const { customs_calendar } = useModuleData();

		// 查询日程数据
		const loadScheduleList = async params => {
			await customs_calendar.refresh(params);
		};
		const getScheduleList = computed(() => customs_calendar.data?.data || []);

		const { goToModule } = useNavigation();
		const goToCalendar = () => {
			goToModule('customs_calendar');
		};

		return {
			calenderCtx: ctx,
			loadScheduleList,
			getScheduleList,
			goToCalendar
		};
	}
};
</script>

<style lang="less" scoped>
.ir-module-block {
	margin-left: -0.12rem;
	margin-right: -0.12rem;
}
.calendar-overview {
	.active-title {
		position: relative;
		padding: 0.2rem 0 0.1rem 0;
		font-weight: 500;
		font-size: 0.15rem;
		line-height: 0.21rem;
		color: #333;
		.position-abs {
			right: 0;
			top: 0.21rem;
		}
	}

	.position-abs {
		position: absolute;
		top: 0.15rem;
		right: 0.12rem;
	}
}
.more {
	padding: 0.14rem 0;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 400;
	font-size: 0.12rem;
	line-height: 0.15rem;
	color: #666;
	.iconjiantouyou {
		font-size: 0.12rem;
	}
}
</style>
